<div class="email-preview-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>E-Mail Vorschau</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="email-content">
    <div class="email-header">
      <div class="email-field">
        <label><strong>Betreff:</strong></label>
        <div class="email-subject">{{ data.subject }}</div>
      </div>
    </div>

    <div class="email-body">
      <label><strong>Inhalt:</strong></label>
      <div class="email-content-html" [innerHTML]="data.content"></div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onClose()">Schließen</button>
  </div>
</div>


